import {
  Component,
  ElementRef,
  ViewChild,
  AfterViewInit,
  NgZone,
} from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from '../../services/local-storage.service';
import { CookieService } from 'ngx-cookie-service';
import { UserState } from 'src/state/user.state';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css'],
})
export class SearchComponent implements AfterViewInit {
  @ViewChild('addresstext') addresstext: ElementRef;

  constructor(
    private _ngZone: NgZone,
    private router: Router,
    public localStorageService: LocalStorageService,
    private cookieService: CookieService,
    private userState: UserState, 
  ) { }

  ngOnInit(): void {
    this.refresh();
    this.localStorageService.remove('myListingId');
    this.localStorageService.remove('addressInfo');
    this.localStorageService.remove('lcAccessToken');
  }
  isLoggedIn: boolean = false;

  refresh() {
    let accessToken = this.cookieService.get("accessToken");
    let userId = this.userState?.getUserDetails?.id;
    let userFullName = this.userState?.getUserDetails?.userFullName;
    if (userId && accessToken && userFullName) {
      this.isLoggedIn = true;
    } else {
      this.isLoggedIn = false;
    }
  }

  ngAfterViewInit(): void {
    this.getPlaceAutocomplete();
  }

  getPlaceAutocomplete() {
    try {
      const autocomplete = new google.maps.places.Autocomplete(
        this.addresstext.nativeElement,
        {
          componentRestrictions: { country: 'US' },
          types: ['establishment', 'geocode'],
        }
      );

      google.maps.event.addListener(autocomplete, 'place_changed', () => {
        let place = autocomplete.getPlace();

        let addressComp = place.address_components;

        let address = place.formatted_address.replace(', USA', '');
        let street_number = '';
        let street = '';
        let city = '';
        let state = '';
        let zip = '';
        for (var value in addressComp) {
          if (
            addressComp[value]['types'] &&
            addressComp[value]['types'].indexOf('street_number') > -1
          ) {
            street_number = addressComp[value]['long_name'];
          } else if (
            addressComp[value]['types'] &&
            addressComp[value]['types'].indexOf('route') > -1
          ) {
            street = addressComp[value]['long_name'];
          } else if (
            addressComp[value]['types'] &&
            (addressComp[value]['types'].indexOf('sublocality_level_1') > -1 ||
              addressComp[value]['types'].indexOf('sublocality') > -1 ||
              addressComp[value]['types'].indexOf('locality') > -1)
          ) {
            city = addressComp[value]['long_name'];
          } else if (
            addressComp[value]['types'] &&
            addressComp[value]['types'].indexOf('administrative_area_level_1') >
            -1
          ) {
            state = addressComp[value]['short_name'];
          } else if (
            addressComp[value]['types'] &&
            addressComp[value]['types'].indexOf('postal_code') > -1
          ) {
            zip = addressComp[value]['long_name'];
          }
        }

        this._ngZone.run(() => {
          this.router.navigate(['/search'], {
            queryParams: {
              address: address,
              street:
                street_number && street_number != ''
                  ? street_number + ' ' + street
                  : street,
              city: city,
              state: state,
              zip: zip,
            },
          });
        });
      });
    } catch (error) {
      console.log(error);
      this.router.navigate(['']);
    }
  }
}
